var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    clipPath: "url(#clip0_999_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.16675 12.5H3.33341C2.89139 12.5 2.46746 12.3244 2.1549 12.0118C1.84234 11.6992 1.66675 11.2753 1.66675 10.8333V3.33329C1.66675 2.89127 1.84234 2.46734 2.1549 2.15478C2.46746 1.84222 2.89139 1.66663 3.33341 1.66663H10.8334C11.2754 1.66663 11.6994 1.84222 12.0119 2.15478C12.3245 2.46734 12.5001 2.89127 12.5001 3.33329V4.16663M9.16675 7.49996H16.6667C17.5872 7.49996 18.3334 8.24615 18.3334 9.16663V16.6666C18.3334 17.5871 17.5872 18.3333 16.6667 18.3333H9.16675C8.24627 18.3333 7.50008 17.5871 7.50008 16.6666V9.16663C7.50008 8.24615 8.24627 7.49996 9.16675 7.49996Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_1261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.da09e7f6.svg";
export { ForwardRef as ReactComponent };